<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text py-2">Anmeldung bestätigen</v-card-title>
      <v-card-text class="pt-4 text-center">
        <v-progress-circular v-if="loading" indeterminate color="primary"></v-progress-circular>
        <div v-else-if="error" class="text-subtitle-2 error--text">{{ error }}</div>
        <div v-else class="text-subtitle-2">
          Danke! Die Anmeldung für euer Team <strong>{{ teamname }}</strong> wurde bestätigt.
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>

import axios from 'axios';

export default {
  name: 'Klopferstock-Bestaetigung',
  props: {
    code: { type: String, required: true },
  },
  data: () => ({
    loading: true,
    error: "",
    teamname: "",
  }),
  mounted(){
    const api = process.env.VUE_APP_APIURL
    axios.post(api+'klopferstock/bestaetigen/', { code: this.code })
      .then((resp) => {
        if (resp.data.success){
          this.teamname = resp.data.teamname
        }else{
          this.error = "Bestätigung fehlgeschlagen."
        }
      })
      .catch((err) => {
        this.error = (err.response && err.response.data && err.response.data.error) || "Bestätigung fehlgeschlagen."
      })
      .finally(() => {
        this.loading = false
      })
  },
}
</script>
